import {useCallback, useEffect, useState} from "react";

import {debounce} from "@pg-mono/nodash";

export const useHorizontalScrollOverlay = (ref: React.RefObject<HTMLOListElement | null>) => {
    const [isLeftOverlayVisible, setLeftOverlay] = useState<boolean>(false);
    const [isRightOverlayVisible, setRightOverlay] = useState<boolean>(false);

    const scrollHandler = useCallback(
        debounce(() => {
            ref.current && ref.current.scrollLeft > 0 ? setLeftOverlay(true) : setLeftOverlay(false);
            ref.current && ref.current.scrollWidth > Math.ceil(ref.current.clientWidth + ref.current.scrollLeft)
                ? setRightOverlay(true)
                : setRightOverlay(false);
        }, 10),
        []
    );

    useEffect(() => {
        ref.current && ref.current.scrollWidth > ref.current.clientWidth ? setRightOverlay(true) : setRightOverlay(false);
        ref.current && ref.current.addEventListener("scroll", scrollHandler);
        return () => {
            ref.current?.removeEventListener("scroll", scrollHandler);
        };
    }, []);

    return {isLeftOverlayVisible, isRightOverlayVisible};
};
import {useCallback, useEffect, useState} from "react";

import {debounce} from "@pg-mono/nodash";

export const useHorizontalScrollOverlay = (ref: React.RefObject<HTMLOListElement | null>) => {
    const [isLeftOverlayVisible, setLeftOverlay] = useState<boolean>(false);
    const [isRightOverlayVisible, setRightOverlay] = useState<boolean>(false);

    const scrollHandler = useCallback(
        debounce(() => {
            ref.current && ref.current.scrollLeft > 0 ? setLeftOverlay(true) : setLeftOverlay(false);
            ref.current && ref.current.scrollWidth > Math.ceil(ref.current.clientWidth + ref.current.scrollLeft)
                ? setRightOverlay(true)
                : setRightOverlay(false);
        }, 10),
        []
    );

    useEffect(() => {
        ref.current && ref.current.scrollWidth > ref.current.clientWidth ? setRightOverlay(true) : setRightOverlay(false);
        ref.current && ref.current.addEventListener("scroll", scrollHandler);
        return () => {
            ref.current?.removeEventListener("scroll", scrollHandler);
        };
    }, []);

    return {isLeftOverlayVisible, isRightOverlayVisible};
};
